import toast from "react-hot-toast";

import { OpenAPI } from "simplydo/interfaces";

import api from "api";

export const openDownloadLink = (url: string, downloadName: string) => {
  const isLocalhost = url.startsWith("http://localhost:4000");
  const isSimplydo = /https:\/\/files(-alpha|-staging)?\.simplydo\.co\.uk/.test(
    url,
  );

  // In almost all regular cases we will operate on simplydo domains (e.g. *.simplydo.co.uk),
  // however in the case of truly cross-origin custom domains the request becomes cross-origin.
  // This can cause issues in browsers when clicking a `download` attribute link, in those cases we open the file in a new tab
  if (isLocalhost || isSimplydo) {
    const a = document.createElement("a");
    a.href = url;
    a.download = downloadName;
    // a.target = "_self";
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    a.remove();
  } else {
    window.open(url, "_blank", "noopener,noreferrer");
  }
};

export const fileDownload = (
  user: OpenAPI.Schemas["User"] & {
    ownerOrganisation: OpenAPI.Schemas["Organisation"];
  },
  event: React.MouseEvent<HTMLAnchorElement>,
  downloadUrl: string,
  downloadName: string,
) => {
  if (!user || !event || !downloadUrl) {
    return;
  }

  event.stopPropagation();
  event.preventDefault();

  const urlData = new URL(downloadUrl);
  const parameters = urlData.searchParams;
  const cookieParams = {
    forType: parameters.get("forType"),
    forId: parameters.get("forId"),
    entityType: parameters.get("entityType"),
    entityId: parameters.get("entityId"),
    identifier: parameters.get("identifier"),
  };

  api.uploads.getFileDownloadCookies(
    cookieParams,
    ({ url }) => {
      openDownloadLink(url, downloadName);
    },
    () => {
      toast.error("Could not download file, please try again later.");
    },
  );
};
